// extracted by mini-css-extract-plugin
module.exports = {"notificationHeader":"_09da0da","ngNotif":"_f4ceb8e","large":"_53e30d1"};